'use client';
import Link from 'next/link';
import { useSearchParams } from 'next/navigation';
import { Divider, Typography } from '@mui/material';
import useHash from '@/customHooks/useHash';
import SSOButtons from './ssoButtons';
import { Stack } from '@mui/system';
import { EmailLogin } from './emailLogin';

export function LoginForm() {
  const searchParams = useSearchParams();
  const hash = useHash();

  const redirectParam = searchParams.get('redirect');
  const nextParam = searchParams.get('next');

  const redirectURL = redirectParam
    ? `${redirectParam}${hash ? `#${hash}` : ''}`
    : null;
  const nextPath = nextParam ? `${nextParam}${hash ? `#${hash}` : ''}` : null;

  return (
    <Stack>
      <Typography variant='h1'> Welcome back to The Urban Developer</Typography>
      <Typography variant='body1'>
        Sign in to your account below. Don't have an account?{' '}
        <Link
          prefetch={false}
          href={'/signup'}
          style={{
            color: '#212221',
            textDecoration: 'underline'
          }}
        >
          Sign up now.
        </Link>
      </Typography>
      <SSOButtons
        nextPath={nextPath ?? undefined}
        redirectURL={redirectURL ?? undefined}
      />
      <Divider>OR CONTINUE WITH EMAIL</Divider>
      <EmailLogin next={nextPath || undefined} />
    </Stack>
  );
}
